import React, { createContext, useContext, useRef } from "react"
import { create, useStore } from "zustand"

type DeleteConfirmationDialogParams = {
  title: string
  content?: string
  handleDelete: () => void
}

interface ConfirmDialogStore {
  deleteConfirmationDialogParams: DeleteConfirmationDialogParams | null
  setDeleteConfirmationDialogParams: (deleteActions: DeleteConfirmationDialogParams) => void
  closeDeleteConfirmationDialog: () => void
}

const createConfirmDialogStore = () => {
  return create<ConfirmDialogStore>((set) => ({
    deleteConfirmationDialogParams: null,
    setDeleteConfirmationDialogParams: (deleteConfirmationDialogParams) => set({ deleteConfirmationDialogParams }),
    closeDeleteConfirmationDialog: () => set({ deleteConfirmationDialogParams: null }),
  }))
}

type ConfirmDialogStoreType = ReturnType<typeof createConfirmDialogStore>

const ConfirmDialogStoreContext = createContext<ConfirmDialogStoreType | null>(null)

type ConfirmDialogStoreProviderProps = React.PropsWithChildren

export const ConfirmDialogStoreProvider = ({ children }: ConfirmDialogStoreProviderProps) => {
  const storeRef = useRef<ConfirmDialogStoreType>(undefined)
  if (!storeRef.current) {
    storeRef.current = createConfirmDialogStore()
  }
  return <ConfirmDialogStoreContext.Provider value={storeRef.current}>{children}</ConfirmDialogStoreContext.Provider>
}

export function useConfirmDialogStoreContext<T>(selector: (state: ConfirmDialogStore) => T): T {
  const store = useContext(ConfirmDialogStoreContext)
  if (!store) throw new Error("Missing ConfirmDialogStoreProvider in the tree")
  return useStore(store, selector)
}
